export const rotateLeft = (arr: any[]) => {
    const first = arr.shift();
    arr.push(first);
    return arr;
}